import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <>
      <section className="info_section layout_padding2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3 info_col">
              <div className="info_contact">
                <h4>Address</h4>
                <div className="contact_link_box">
                  <a href="#">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    <span>Mwanga Tower, 10th Floor, Makumbusho, Dar es Salaam, Tanzania</span>
                  </a>
                  <a href="tel:+255717039523">
                    <i className="fa fa-phone" aria-hidden="true"></i>
                    <span>Call +255-717039523</span>
                  </a>
                  <a href="mailto:info@mkavanco.co.tz">
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                    <span>info@mkavanco.co.tz</span>
                  </a>
                </div>
              </div>
              <div className="info_social">
                <a href="#">
                  <i className="fa fa-facebook" aria-hidden="true"></i>
                </a>
                <a href="#">
                  <i className="fa fa-twitter" aria-hidden="true"></i>
                </a>
                <a href="#">
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
                <a href="#">
                  <i className="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 info_col">
              <div className="info_detail">
                <h4>Info</h4>
                <p>Feel free to reach out to us for any inquiries or feedback. We are here to help you with all your logistics needs.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-2 mx-auto info_col">
              <div className="info_link_box">
                <h4>Links</h4>
                <div className="info_links">
                  <a className="active" href="/">
                    <img src="/images/nav-bullet.png" alt="" />
                    Home
                  </a>
                  <a className="" href="/about-us">
                    <img src="/images/nav-bullet.png" alt="" />
                    About
                  </a>
                  <a className="" href="/services">
                    <img src="/images/nav-bullet.png" alt="" />
                    Services
                  </a>
                  <a className="" href="/contact">
                    <img src="/images/nav-bullet.png" alt="" />
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 info_col">
              <h4>Subscribe</h4>
              <form action="#">
                <input type="text" placeholder="Enter email" />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="footer_section">
        <div className="container">
          <p>
            &copy; {currentYear} All Rights Reserved By
            <a href="https://mkavanco.co.tz/"> Designed with Love by MKAVANCO</a>
          </p>
        </div>
      </section>
    </>
  );
}

export default Footer;